import { Card } from 'antd';
import Title from 'antd/lib/typography/Title';
import { Maybe } from 'graphql/jsutils/Maybe';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { extractTranslation } from '../../helpers/formatters';
import { parseHtml } from '../../helpers/safe-html';
import { Form_FormQuestionMsg, Form_FormValueType } from '../../src/generated/graphql';

interface QuestionHeaderProps {
  question: Maybe<Form_FormQuestionMsg> | undefined;
}

export const QuestionHeader: FC<QuestionHeaderProps> = ({ question }) => {
  const locale = useRouter().locale;

  const title = extractTranslation(question?.title, locale);
  const subtitle = extractTranslation(question?.subtitle, locale);
  const titleHtml = extractTranslation(question?.titleHtml, locale);
  const subtitleHtml = extractTranslation(question?.subtitleHtml, locale);
  const type = question?.type;
  const isTypeInfoText = type === Form_FormValueType.FormValueTypeInfoText;

  return (
    <Card>
      {title ? (
        <Title level={4}>{title}</Title>
      ) : (
        titleHtml && (
          <Title level={4}>
            <span>{parseHtml(titleHtml)}</span>
          </Title>
        )
      )}
      {!isTypeInfoText &&
        (subtitle ? (
          <span>{subtitle}</span>
        ) : (
          subtitleHtml && <span>{parseHtml(subtitleHtml)}</span>
        ))}
    </Card>
  );
};
